export default __webpack_public_path__ + "static/media/4.056a8a9a.jpg";